export default {
  edi: {
    title: "EDI",
    profile: "윤곽",
    profile_name: "프로필 이름",
    im: "수입",
    ex: "수출",
    table: "표 이름",
    type: "EDI 유형",
    column: '기둥',
    submit: '복종시키다',
    close: '승인',
    columnData: '열 데이터',
    chooseColumn: '열 선택',
    selected: '선택된',
    select: '고른',
    selectColumn: '열을 선택하십시오.',
    primary_key: '기본 키',
    column_mapping: '열 매핑',
    update_conditions: '조건 업데이트',
    select_profile: '프로필 선택',
    select_file: '파일 업로드 및 열 일치',
    start_upload: '업로드 데이터 시작',
    result: {
      success: '가져 오기 결과 : 삽입 됨 {inserted} 목, 업데이트 됨: {updated} 목!',
      failure: '가져 오기 실패!'
    },
    file: {
      select: '파일을 선택하십시오.',
      tryAgain: '다른 파일 선택',
      withHeaders: 'This file includes headers',
      withoutHeaders: 'This file does not include headers',
    },
    error: {
      title: 'Error',
      columnNumber: 'You do not have enough columns. <br><b>Required columns are</b>: ',
      missingColumns: 'Missing required columns:',
      selectColumn: 'You need to select all columns',
      fileNumber: 'You need to select a file',
      fileSelection: 'No file has been selected',
      invalidFile: 'This file is invalid. Try to use a CSV or Xlsx file',
      noWorksheet: 'Must have at least one worksheet',
      emptyWorksheet: '워크 시트가 비어 있습니다.',
    },
  }
};
